export enum FULFILLMENT_COLORS {
  RED = "#F47777",
  YELLOW = "#C9B543",
  GREEN = "#82D173",
  LIGHTGREEN = "#C2FF8D",
  PLAN = "#D5D5D5",
  GRAY = "#808080",
}
